// 函数防抖
const debounce = function(callback, delay = 1000) {
	let timer = null;
	return function() {
		let self = this;
		let args = arguments;
		timer && clearTimeout(timer)
		timer = setTimeout(function() {
			callback.apply(self, args)
		}, delay);
	}
}

// 节流 定时器方案
const throttle = (fn, wait) => {
	let timer = null;
	return function() {
		let context = this;
		let args = arguments;
		if (!timer) {
			timer = setTimeout(function() {
				fn.apply(context, args);
				timer = null;
			}, wait)
		}
	}
}
const stripscript = (s) => {
	if(!s){
		return '';
	}
	var pattern = new RegExp("[`~!@#$^&*()=|{}':;',\\[\\].<>/?~！@#￥……&*（）——|{}【】‘；：”“'。，、？]");
	var rs = "";
	for (var i = 0; i < s.length; i++) {
		rs = rs + s.substr(i, 1).replace(pattern, '');
	}
	return rs;
}
const delCookie = () => {
	var cookies = document.cookie.split(";");
	for (var i = 0; i < cookies.length; i++) {
		var cookie = cookies[i];
		var eqPos = cookie.indexOf("=");
		var name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
		document.cookie =
			name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/";
	}
	if (cookies.length > 0) {
		for (var i = 0; i < cookies.length; i++) {
			var cookie = cookies[i];
			var eqPos = cookie.indexOf("=");
			var name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
			var domain = location.host.substr(location.host.indexOf("."));
			document.cookie =
				name +
				"=;expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; domain=" +
				domain;
		}
	}
}

export function ToHump(name) {
  if (name.includes("_")) {
    let oarr = name.split("_");
    for (let i = 1; i < oarr.length; i++) {
      oarr[i] = oarr[i].charAt(0).toUpperCase() + oarr[i].slice(1);
    }
    return oarr.join("");
  }
  return name;
}
 
export function HumpObj(obj) {
  let humpObj = Object.assign({},obj);
  for (let key in obj) {
	  if(!!humpObj[ToHump(key)]){
		  continue;
	  }
    humpObj[ToHump(key)] = obj[key];
 
    if (obj[key] && obj[key] instanceof Object) {
      humpObj[ToHump(key)] = HumpObj(obj[key]);
    }
  }
  return humpObj;
}

export {
	debounce,
	throttle,
	stripscript,
	delCookie
}
